export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Individuals.07fff31e.png";